// @ts-nocheck
import { DataGrid, GridColumnMenuContainer, GridColumnMenuFilterItem, GridColumnMenuSortItem, getGridStringOperators } from '@mui/x-data-grid';
import { Box, IconButton, MenuItem, Select, Typography } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

function CustomColumnMenu(props) {
  const { hideMenu, colDef } = props;

  return (
    <GridColumnMenuContainer {...props}>
      <GridColumnMenuSortItem onClick={hideMenu} colDef={colDef} />
      <GridColumnMenuFilterItem onClick={hideMenu} colDef={colDef} />
    </GridColumnMenuContainer>
  );
}

const supportedStringFilterOperators = ['startsWith', 'equals']
  .map((operatorValue) => getGridStringOperators().find(({ value }) => value === operatorValue))
  .filter(Boolean);

export default function ErrorsDataGrid(props) {
  const {
    rows = [],
    loading = false,
    defaultPageSize = 10,
    pageSizeOptions = [10, 15, 25],
    page,
    pageSize,
    hasMore = false,
    filterModel,
    onFilterModelChange,
    onRowView,
  } = props;

  const safeRows = (rows || []).map((row, index) => ({ id: row.id ?? `row-${index}`, ...row }));

  const columns = [
    {
      field: 'patientId',
      headerName: 'Patient ID',
      flex: 1.8,
      minWidth: 260,
      filterOperators: supportedStringFilterOperators,
    },
    {
      field: 'userId',
      headerName: 'User ID',
      flex: 1.6,
      minWidth: 220,
      filterOperators: supportedStringFilterOperators,
    },
    {
      field: 'api',
      headerName: 'API',
      flex: 1.2,
      minWidth: 180,
      filterOperators: supportedStringFilterOperators,
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 100,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        const errorRecord = params.row || {};

        return (
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', height: '100%', justifyContent: 'center' }}>
            <IconButton
              size="small"
              sx={{ width: 28, height: 28, p: 0.25 }}
              aria-label={`view-${errorRecord.id}`}
              title={`View ${errorRecord.patientId || errorRecord.id || ''}`}
              onClick={() => typeof onRowView === 'function' && onRowView(errorRecord)}
            >
              <VisibilityIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </div>
        );
      },
    },
  ];

  return (
    <div
      style={{
        width: '90%',
        maxWidth: 1600,
        margin: '0 auto',
        paddingTop: '2.5vw',
        paddingBottom: '1.5vw',
      }}
    >
      <div
        style={{
          border: '1px solid #e0e0e0',
          borderRadius: 8,
          background: '#fff',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingTop: 12,
            paddingBottom: 8,
            paddingLeft: 12,
            paddingRight: 12,
          }}
        >
          <div style={{ fontWeight: 400, fontSize: 32 }}>Errors</div>
        </div>
        <DataGrid
          rows={safeRows}
          loading={loading}
          columns={columns}
          filterMode="server"
          filterModel={filterModel}
          onFilterModelChange={onFilterModelChange}
          slots={{ columnMenu: CustomColumnMenu }}
          density="compact"
          rowHeight={85}
          hideFooter
          sx={{
            border: 'none',
            borderRadius: 0,
            width: '100%',
            maxWidth: '100%',
            mt: 0,
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: 'transparent',
            },
            '& .MuiDataGrid-columnHeader': {
              backgroundColor: 'transparent',
            },
            '& .MuiDataGrid-columnHeaderTitle': {
              fontWeight: 590,
              color: 'common.black',
              fontSize: 17,
            },
            '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
              outline: 'none',
            },
            '& .MuiDataGrid-row': {
              minHeight: 64,
              maxHeight: 64,
            },
          }}
          aria-label="Errors table"
        />
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: 3,
            px: 2,
            py: 1,
            borderTop: '1px solid #e0e0e0',
            flexWrap: 'wrap',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Rows per page
            </Typography>
            <Select
              id="error-page-size"
              size="small"
              value={pageSize ?? defaultPageSize}
              onChange={(event) => {
                if (typeof props.onPageSizeChange === 'function') {
                  props.onPageSizeChange(Number(event.target.value));
                }
              }}
              disabled={loading}
              MenuProps={{ disableScrollLock: true }}
              sx={{
                minWidth: 72,
                '& .MuiSelect-select': {
                  py: 0.75,
                  pr: 3,
                  fontSize: 14,
                },
              }}
            >
              {pageSizeOptions.map((option) => (
                <MenuItem key={option} value={option}>{option}</MenuItem>
              ))}
            </Select>
          </Box>
          <Typography variant="body2" sx={{ color: 'text.secondary', minWidth: 56, textAlign: 'center' }}>
            {(page ?? 0) + 1}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton
              size="small"
              onClick={() => typeof props.onPageChange === 'function' && props.onPageChange((page ?? 0) - 1)}
              disabled={loading || (page ?? 0) <= 0}
              aria-label="Previous page"
            >
              <KeyboardArrowLeftIcon fontSize="small" />
            </IconButton>
            <IconButton
              size="small"
              onClick={() => typeof props.onPageChange === 'function' && props.onPageChange((page ?? 0) + 1)}
              disabled={loading || !hasMore}
              aria-label="Next page"
            >
              <KeyboardArrowRightIcon fontSize="small" />
            </IconButton>
          </Box>
        </Box>
      </div>
    </div>
  );
}